import { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

type TypeAreaBoxParam = {
  updateId: number
  value: string
  placeholder: string
  updateValue?: ((v: string) => void) | undefined
  isShowButtons: boolean
  height?: string
  setFocusTextArea?: (v: boolean) => void
}

const TextAreaBox = (props: TypeAreaBoxParam) => {
  const [value, setValue] = useState(props.value)
  const [showTextArea, setShowTextArea] = useState(false)
  const textareaRef = useRef<HTMLTextAreaElement>(null)
  const [focusTextArea, setFocusTextArea] = useState(false)
  const [initialValue, setInitialValue] = useState('')

  useEffect(() => {
    setShowTextArea(false)
    setInitialValue(props.value)
  }, [props.updateId])

  useEffect(() => {
    setValue(props.value)
  }, [props.value])

  const handleChangeTextArea = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const {
      target: { value },
    } = event

    setValue(value)
  }

  const handleClickApply = () => {
    setShowTextArea(false)

    setInitialValue(value)
    if (props.updateValue !== undefined) {
      props.updateValue(value)
    }
  }

  const handleClickCancel = () => {
    setValue(initialValue)
    setShowTextArea(false)
  }

  const handleClickBox = () => {
    setShowTextArea(true)
    setFocusTextArea(true)
  }

  useEffect(() => {
    if (focusTextArea) {
      textareaRef.current?.focus()
      textareaRef.current?.scrollIntoView()
      setFocusTextArea(false)
    }
  }, [focusTextArea])

  const handleBlurTextArea = () => {
    if (props.isShowButtons === false) {
      handleClickApply()
    }
  }

  return (
    <Container>
      {showTextArea ? (
        <>
          <Textarea
            ref={textareaRef}
            onChange={handleChangeTextArea}
            onBlur={handleBlurTextArea}
            placeholder={props.placeholder}
            value={value}
            height={props.height}
          ></Textarea>
          {props.isShowButtons && (
            <>
              <button onClick={handleClickApply}>적용</button>
              <button onClick={handleClickCancel}>취소</button>
            </>
          )}
        </>
      ) : (
        <Box onClick={handleClickBox} height={props.height}>
          {value === '' ? <span>{props.placeholder}</span> : value}
        </Box>
      )}
    </Container>
  )
}

const Container = styled.div`
  button {
    padding: 10px 30px;
    border: none;
    background-color: orange;
    margin-right: 10px;
  }
  button:nth-child(3) {
    background-color: #dadada;
  }
`
const Textarea = styled.textarea<{ height: string | undefined }>`
  width: 100%;
  height: ${(props) => (props.height ? props.height : '80px')};
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #ddd;
  font-size: 0.9rem;
`

const Box = styled.div<{ height: string | undefined }>`
  font-size: 1rem;
  box-sizing: border-box;
  white-space: pre-wrap;
  line-height: 1.6;
  padding: 10px;
  border: 1px solid #ddd;
  height: ${(props) => (props.height ? props.height : '80px')};

  span {
    color: #ddd;
  }
`

export default TextAreaBox
